import React from 'react';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const BreadcrumbsNav: React.FC<{ current: string }> = ({ current }) => {
  const navigate = useNavigate();
  return (
    <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
      <Link underline="hover" color="inherit" onClick={() => navigate('/')} sx={{ cursor: 'pointer' }}>
        Home
      </Link>
      <Typography color="text.primary">{current}</Typography>
    </Breadcrumbs>
  );
};

export default BreadcrumbsNav;
